






































































































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { CampaignListModule } from '@/store/modules/campaignList';
import { OPPORTUNITY_SOURCE_CODE_CAMPAIGN } from '@/models/Opportunities/OpportunitySourceDto';
import ListUtils from '@/lib/listUtils';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';

@Component({ name: 'OpportunityGeneralDetailsEdit' })
export default class extends GiganautVueDialog {
  entity = {
    name: '',
    workTypes: [] as string[],
    sourceId: null as string | null,
    campaignId: null as string | null,
    value: 0,
    valueType: 1,
    expectedCloseDate: '' as string,
  };
  selectedOwner: any = null;
  selectedBranch: any = null;
  selectedDesk: any = null;
  includeClosedCampaigns = false;

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }
  get agencyUsers() { return AgencySettingsModule.agencyUsers; }
  get branches() { return AgencySettingsModule.branches; }
  get opportunitySources() { return AgencySettingsModule.opportunitySources; }
  get campaigns() { return CampaignListModule.campaigns; }
  get loadingCampaigns() { return CampaignListModule.loading; }
  get desks() {
    if (!this.selectedBranch) return [];
    const branch = AgencySettingsModule.branches.find((b: any) => b.id === this.selectedBranch.id);
    return branch ? branch.desks : [];
  }

  get workTypeOptions() {
    return ListUtils.workTypes();
  }

  get valueTypeOptions() {
    // Mirrors OPPORTUNITY_VALUE_TYPE_* constants in api/core/opportunities.go.
    return [
      { value: 1, label: 'One Off' },
    ];
  }

  get isCampaignSource(): boolean {
    const src = this.opportunitySources.find((s: any) => s.id === this.entity.sourceId);
    return !!src && src.isSystem && src.code === OPPORTUNITY_SOURCE_CODE_CAMPAIGN;
  }

  ownerLabel(item: any) {
    return item.person ? `${item.person.firstName} ${item.person.lastName}` : '';
  }

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (!val || !this.opportunity) return;
    const opp = this.opportunity;
    this.entity = {
      name: opp.name,
      workTypes: Array.isArray(opp.workTypes) ? [...opp.workTypes] : [],
      sourceId: opp.sourceId,
      campaignId: opp.campaignId,
      value: opp.value,
      valueType: opp.valueType || 1,
      // Backend returns the date as a full RFC3339 timestamp (`*time.Time` JSON
      // marshalling), but the date input expects `YYYY-MM-DD`, and the backend
      // also re-validates the same on save. Trim to the date portion.
      expectedCloseDate: opp.expectedCloseDate ? opp.expectedCloseDate.substring(0, 10) : '',
    };
    // Pre-load reference data the form needs.
    if (AgencySettingsModule.agencyUsers.length === 0) {
      await AgencySettingsModule.getAgencyUsers();
    }
    if (AgencySettingsModule.branches.length === 0) {
      await AgencySettingsModule.getBranches();
    }
    if (AgencySettingsModule.opportunitySources.length === 0) {
      await AgencySettingsModule.getOpportunitySources();
    }
    await this.fetchCampaigns();
    // If the loaded opportunity references a campaign that's now closed, ensure
    // it remains visible in the dropdown by flipping the toggle on and refetching.
    if (opp.campaignId && !CampaignListModule.campaigns.some((c: any) => c.id === opp.campaignId)) {
      this.includeClosedCampaigns = true;
    }
    // Resolve current selections against the loaded reference lists.
    this.selectedOwner = opp.ownerId
      ? AgencySettingsModule.agencyUsers.find((u: any) => u.id === opp.ownerId) || null
      : null;
    this.selectedBranch = opp.branchId
      ? AgencySettingsModule.branches.find((b: any) => b.id === opp.branchId) || null
      : null;
    this.selectedDesk = (this.selectedBranch && opp.deskId)
      ? (this.selectedBranch.desks || []).find((d: any) => d.id === opp.deskId) || null
      : null;
  }

  @Watch('selectedBranch')
  onBranchChanged(newBranch: any, oldBranch: any) {
    // Switching branch nukes the desk selection (desks belong to a branch).
    if (oldBranch && (!newBranch || oldBranch.id !== newBranch.id)) {
      this.selectedDesk = null;
    }
  }

  @Watch('entity.sourceId')
  onSourceChanged() {
    // Source moved off 'Campaign' — clear the linked campaign so we don't
    // send an orphan campaignId for an opportunity whose source no longer
    // implies a campaign relationship.
    if (!this.isCampaignSource) {
      this.entity.campaignId = null;
    }
  }

  @Watch('includeClosedCampaigns')
  onIncludeClosedCampaignsChanged() {
    this.fetchCampaigns();
  }

  async fetchCampaigns() {
    const statuses = this.includeClosedCampaigns
      ? [CampaignStatus.Active, CampaignStatus.Closed]
      : [CampaignStatus.Active];
    await CampaignListModule.fetchCampaignsByStatuses(statuses);
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    await OpportunityDetailsModule.updateGeneralDetails({
      id: this.opportunity.id,
      updatedAt: this.opportunity.updatedAt,
      name: this.entity.name,
      workTypes: this.entity.workTypes,
      sourceId: this.entity.sourceId,
      campaignId: this.entity.campaignId,
      value: this.entity.value,
      valueType: this.entity.valueType,
      expectedCloseDate: this.entity.expectedCloseDate || '',
      ownerId: this.selectedOwner ? this.selectedOwner.id : null,
      branchId: this.selectedBranch ? this.selectedBranch.id : null,
      deskId: this.selectedDesk ? this.selectedDesk.id : null,
    });
    this.dialog = false;
  }
}
